var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `col xs-8 sm-8 md-4 lg-4 xl-4 tile relative ${_vm.selectedClass}`,
      on: { click: _vm.paymentTileSelected },
    },
    [
      _vm.showTileDealMessaging
        ? _c(
            "div",
            {
              staticClass: "absolute top-0 left-0",
              class:
                this.isPhoenixPhaseThreeCustomer &&
                _vm.SFDCPaymentTypeToVariableName[_vm.paymentPlan] === "monthly"
                  ? "messaging light-tile-banner"
                  : "messaging",
            },
            [_vm._v(" " + _vm._s(_vm.tileDealMessaging))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "tile-info" }, [
        _c("div", [
          _c(
            "h4",
            { staticClass: "header-styling", class: _vm.headerStyling },
            [_vm._v(_vm._s(_vm.paymentHeader))]
          ),
          _vm._v(" "),
          _vm.paymentSubHeader
            ? _c(
                "div",
                { staticClass: "sub-header-styling mb-1 bold text-xl" },
                [_vm._v(_vm._s(_vm.paymentSubHeader))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: this.isPhoenixPhaseThreeCustomer
                ? "monthly-cost !mb-0"
                : "monthly-cost",
            },
            [_vm._v(_vm._s(_vm.monthlyCost))]
          ),
          _vm._v(" "),
          _vm.showTileDealMessaging
            ? _c(
                "div",
                {
                  staticClass: "list-price-styling line-through text-gray-500",
                },
                [
                  _vm._v(
                    _vm._s(
                      `${_vm.currencySymbol}${_vm.monthlyListPriceCost.toFixed(
                        2
                      )}/${
                        _vm.renewalsPersistedVariables.jsonContent.text.month
                      }`
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPhoenixPhaseTwoCustomer && _vm.totalSavings
            ? _c("div", { staticClass: "total-savings" }, [
                _vm._v("Save " + _vm._s(_vm.totalSavings) + " in total"),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isPhoenixPhaseThreeCustomer
            ? _c("div", { domProps: { innerHTML: _vm._s(_vm.breakdown) } })
            : _vm._e(),
          _vm._v(" "),
          _vm.discount
            ? _c("div", { staticClass: "save bold" }, [
                _vm._v(_vm._s(_vm.discount)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.phoenixExptChanges
            ? _c(
                "div",
                {
                  staticClass:
                    "flex justify-center mt-1 total-payments text-center",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.totalMessaging) +
                      " \n            "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }